import AuthenticatedController from './AuthenticatedController';
import { FACEBOOK_PAGE_VARIABLES } from '@mm/api-routes';

export default class VariablesController extends AuthenticatedController {
  static async getAll(facebookPageId) {
    const response = await super.get(FACEBOOK_PAGE_VARIABLES(facebookPageId));

    return response;
  }
}
